import React from "react";

const MainContent = ({ children, className = "" }) => {
  return (
    <div className={`pb-20 px-12 flex justify-center ${className}`}>
      <div className="bg-transparent border-2 border-white rounded-2xl shadow-xl w-full max-w-7xl p-10 mt-[7rem] backdrop-blur-[2px]">
        {children}
      </div>
    </div>
  );
};

export default MainContent;